import {
    FaRegCalendarCheck,
    FaRegClock,
} from "react-icons/fa6";

import {
    MdOutlineDateRange,
} from "react-icons/md";

import styles from "./MembershipSection.module.css";

const MembershipSection = ({

    membershipDate = "",

    expireDate = "",

    lastLogin = "",

}) => {

    return (

        <section className={styles.card}>

            <div className={styles.row}>

                <div className={styles.left}>

                    <MdOutlineDateRange

                        className={styles.icon}

                    />

                    <span>

                        تاریخ عضویت

                    </span>

                </div>

                <span className={styles.value}>

                    {membershipDate}

                </span>

            </div>

            <div className={styles.divider} />

            <div className={styles.row}>

                <div className={styles.left}>

                    <FaRegCalendarCheck

                        className={styles.icon}

                    />

                    <span>

                        تاریخ انقضاء

                    </span>

                </div>

                <span className={styles.value}>

                    {expireDate}

                </span>

            </div>

            <div className={styles.divider} />

            <div className={styles.row}>

                <div className={styles.left}>

                    <FaRegClock

                        className={styles.icon}

                    />

                    <span>

                        آخرین ورود

                    </span>

                </div>

                <span className={styles.value}>

                    {lastLogin}

                </span>

            </div>

        </section>

    );

};

export default MembershipSection;